module.exports = __webpack_public_path__ + "media/images/medal_1-3d24a4a7f3e56cd3f00643d458150686.svg";